import { DEFAULT_EMPTY } from '@/utils/constant'
import { parseExtension, generateResultTemplates } from '../common-query/commonUtils'
import { CAR_PURCHASE_CONFIG } from '../card-page/cardConfigs'

/**
 * 处理购车进度卡片的数据
 * 使用 cardConfigs.js 中的配置
 * @param {Object} response - 接口返回的响应数据
 * @param {Vue} vm - Vue 组件实例，用于访问 DEFAULT_EMPTY
 */
export function processProgressData(response, vm) {
	const emptyValue = DEFAULT_EMPTY
	// 解析 extension 字段获取审核历史
	const extensionStr = response?.extension
	const extensionList = parseExtension(extensionStr)
	console.log('extensionList==>', extensionList)
	// 使用配置中的 infoFields 生成 infoArray
	vm.infoArray = CAR_PURCHASE_CONFIG.infoFields.map(field => {
		let value = response[field.key] || emptyValue
		if (field.firstListItem && extensionList.length > 0) {
			value = extensionList[0][field.key] || emptyValue
		}
		return ({
			label: field.label,
			value: value,
			key: field.key
		})
	})

	// 字段映射：接口字段 -> 配置字段
	const mappedList = extensionList.map(item => ({
		orderStatus: item?.orderStatus || '',
		dealerName: item?.dealerName || '',
		dealerPhone: item?.dealerPhone || '',
		color: item?.color || '',
		remark: item?.remark || ''
	}))

	// 使用配置中的 fieldConfigs 生成 resultTemplates
	vm.resultTemplates = generateResultTemplates(mappedList, CAR_PURCHASE_CONFIG.fieldConfigs)
}
